export const convertStatus = (status: string) => {
  return status === 'successful' ? '終了'
    : status === 'processing' || status === 'pending' ? '処理中'
      : '確認事項あり'
}

export const convertPermission = (permission: string, id: string) => {
  if (id !== '10008') return permission
  return permission === '国立国会図書館内限定公開（スニペット禁止）' ? '国立国会図書館内限定'
    : permission === 'インターネット公開' ? '登録無しで閲覧可能'
      : permission
}
